/**
 * Testing utilities for @firesystem/indexeddb
 * 
 * This module provides helpers for testing with IndexedDBFileSystem
 * in Node.js environments where IndexedDB is not available.
 */

// Check if we're in a Node.js environment and load polyfill
if (typeof globalThis.indexedDB === "undefined") {
  try {
    // Use require for synchronous loading
    require("fake-indexeddb/auto");
  } catch (error) {
    // Try dynamic import as fallback
    import("fake-indexeddb/auto").catch(() => {
      console.warn(
        "⚠️  IndexedDB not found. To test @firesystem/indexeddb in Node.js, install fake-indexeddb:\n" +
        "    npm install --save-dev fake-indexeddb"
      );
    });
  }
}

export { IndexedDBFileSystem } from "./IndexedDBFileSystem";
export * from "./types";